import * as Yup from "yup";

export const nftListSchema = Yup.object().shape({
  MaticPrice: Yup.number()
    .moreThan(0, "Price must be greater than 0.")
    .positive("Price must be greater than 0.")
    .lessThan(99999999, "Price must be lower than 99999999")
    .typeError("Price must be greater than 0."),
});
